import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import type User from 'modules/core/store/models/User'

interface Props {
  user: User
}

export default function EmployeeLabelSupervisor({ user }: Props) {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <UserAvatar size="s40" user={user} />
      <Box>
        <Text.Normal weight="medium">{user.fullName()}</Text.Normal>
      </Box>
    </Box>
  )
}
